import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StockStats from './stock-stats';

export const StockStatsWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <StockStats customClass="external-widget" widget={true} />
    </QueryClientProvider>
  );
};
